import React from 'react'
import { Button, Form, Input, Radio } from 'antd'

// mobx
import { useStore } from '@/store'
import { set, runInAction, toJS } from 'mobx'
import { observer } from 'mobx-react-lite'
// mobx
import { validatLength } from '@/utils/check'


const RoleInput = ({ title }) => {
  const { RoleStore } = useStore()

  // 取消按钮
  const [form] = Form.useForm()
  

  //表单提交
  const onFinish = async (values) => {
    if (title === '添加') {
      const { name, describe } = values
      await RoleStore.getAddButtom({name, describe})
    } else if (title === '编辑') {
      await RoleStore.getPutInformation(values)
    }
    runInAction(() => {
      set(RoleStore, { isActive: false })
    })
    form.resetFields()
  };

  return (
    <>
      {
        title === '添加' && <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          form={form}
          onFinish={onFinish}
          initialValues={{
            xtzt: 1
          }}
        >
          <Form.Item label="名称" name="name" rules={[
            {
              required: true,
              message: '请输入名称',
            },
            {
              validator: validatLength
            }
          ]}>
            <Input placeholder="请输入系统编号" />
          </Form.Item>
          <Form.Item label="描述" name="describe" rules={[
            {
              required: true,
              message: '请输入描述',
            }
          ]}>
            <Input.TextArea showCount maxLength={100} style={{ height: 120, resize: 'none', }} placeholder="请输入信息" />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 6 }}>
            <Button type="primary" htmlType="submit">
              立即添加
            </Button>
          </Form.Item>
        </Form>
      }
      {
        title === '编辑' && <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          form={form}
          onFinish={onFinish}
          initialValues={toJS(RoleStore.valueData)}
        >
           <Form.Item label="名称" name="name" rules={[
            {
              required: true,
              message: '请输入名称',
            },
            {
              validator: validatLength
            }
          ]}>
            <Input placeholder="请输入系统编号" />
          </Form.Item>
          <Form.Item label="描述" name="describe" rules={[
            {
              required: true,
              message: '请输入描述',
            }
          ]}>
            <Input.TextArea showCount maxLength={100} style={{ height: 120, resize: 'none', }} placeholder="请输入信息" />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 6 }}>
            <Button type="primary" htmlType="submit">
              修改内容
            </Button>
          </Form.Item>
        </Form>
      }
    </>
  )
}

export default observer(RoleInput)